import React, { useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        escolaId: 0
      },
      location
    )
  );
  const [comboEscolas, setComboEscolas] = useState([]);
  const [turmas, setTurmas] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (filtros.escolaId) listar();
    carregarComboEscolas();
  }, []);

  const carregarComboEscolas = () => {
    api.get("turmas/listarEscolasTurmas", { ativas: true }).then(escolas => {
      setComboEscolas(escolas);
    });
  };

  const listar = (filtrosEnviar = filtros) => {
    setCarregando(true);
    setFiltros(filtrosEnviar);
    
    api.get("turmas/listar", filtrosEnviar).then(turmas => {
      turmas.forEach(t => t.valorMaterial = t.valorMaterialCentavos ? (t.valorMaterialCentavos/100).toFixed(2) : 0)
      setTurmas(turmas);
      setCarregando(false);
    });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      escolaId: {
        label: "Escola",
        type: "select",
        value: filtros.id,
        space: 10,
        array: {
          data: comboEscolas,
          value: "escolaId",
          desc: "escolaNomeFantasia",
        },
        emptyItem: true,
        emptyItemText: "(Selecione)",
      },
      exibirInativos: {
        type: "check",
        label: "Exibir inativos",
        space: 2,
        value: filtros.exibirInativos,
      },
    },
    submit: {
      label: "Buscar",
      action: listar,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirDados = (registro) => {
    history.push(`/app/turmas/${registro.id}`);
  };

  const tRegistros = {
    title: "Turmas",
    newItemAction: () => history.push("/app/turmas/0"),
    onLineClick: abrirDados,
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
      {
        label: "Valor do material (R$)",
        name: "valorMaterial",
      },
    ],
    array: turmas,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
